export default __webpack_public_path__ + "static/media/logo4.5675477c.png";